//
window.COLOR = {

	black : {
		txt : {
			// rgb : { r:0,g:0,b:0 },
			rgb : { r:25,g:25,b:25 },
			hex : null,
			ogl : null,
		},
		bg : {
			// rgb : { r:0,g:0,b:0 },
			rgb : { r:19,g:19,b:19 },
			hex : null,
			ogl : null,
		},
	},

	white : {
		txt : {

			// rgb : {
			// 	r: Math.floor(242 * 1),
			// 	g: Math.floor(240 * 1),
			// 	b: Math.floor(236 * 1)
			// },

			rgb : {
				r:243,
				g:242,
				b:238
			},

			// rgb : {
			// 	r:230,
			// 	g:225,
			// 	b:220
			// },

			hex : null,
			ogl : null,
		},
		bg : {

			// rgb : {
			// 	r: Math.floor(242 * 1),
			// 	g: Math.floor(240 * 1),
			// 	b: Math.floor(236 * 1)
			// },

			rgb : {
				r:243,
				g:242,
				b:238
			},

			hex : null,
			ogl : null,
		}
	},

	rgbObjectToHex(rgbObj) {
		function componentToHex(c) {
			var hex = c.toString(16);
			return hex.length == 1 ? "0" + hex : hex;
		}
		const r = componentToHex(rgbObj.r);
		const g = componentToHex(rgbObj.g);
		const b = componentToHex(rgbObj.b);
		return "#" + r + g + b;
	},

	hexToRgb(hex) {
		if (hex.length === 4) {
			hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
		}
		var bigint = parseInt(hex.slice(1), 16);
		var r = (bigint >> 16) & 255;
		var g = (bigint >> 8) & 255;
		var b = bigint & 255;
		return "rgb(" + r + ", " + g + ", " + b + ")";
	},

	once(){
		this.black.txt.hex = this.rgbObjectToHex( this.black.txt.rgb );
		this.white.txt.hex = this.rgbObjectToHex( this.white.txt.rgb );
		this.black.txt.ogl = new OGL.Color( this.black.txt.hex );
		this.white.txt.ogl = new OGL.Color( this.white.txt.hex );
		this.black.bg.hex  = this.rgbObjectToHex( this.black.bg.rgb );
		this.white.bg.hex  = this.rgbObjectToHex( this.white.bg.rgb );
		this.black.bg.ogl  = new OGL.Color( this.black.bg.hex );
		this.white.bg.ogl  = new OGL.Color( this.white.bg.hex );
		$html.style.setProperty('--col-black', 'rgb(' + this.black.txt.rgb.r + ',' + this.black.txt.rgb.g + ',' + this.black.txt.rgb.b + ')' );
		$html.style.setProperty('--col-white', 'rgb(' + this.white.txt.rgb.r + ',' + this.white.txt.rgb.g + ',' + this.white.txt.rgb.b + ')' );
		$html.style.setProperty('--col-border', 'rgba(' + this.white.txt.rgb.r + ',' + this.white.txt.rgb.g + ',' + this.white.txt.rgb.b + ',0.15)' );
		$html.style.setProperty('--bg-black', 'rgb(' + this.black.bg.rgb.r + ',' + this.black.bg.rgb.g + ',' + this.black.bg.rgb.b + ')' );
		$html.style.setProperty('--bg-white', 'rgb(' + this.white.bg.rgb.r + ',' + this.white.bg.rgb.g + ',' + this.white.bg.rgb.b + ')' );
	}

}

COLOR.once();